/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react'
import BodyForm from './BodyForm'
import { useLocation, useNavigate } from 'react-router-dom'
import queryString from 'query-string'
import { __ShowForm } from 'request/Forms/__ShowForm'
import { useSelector, useDispatch } from 'react-redux'
import environment from 'constants/apiConst'
import { HeaderForm } from 'components/HeaderForm/HeaderForm'
import { setFormData, clearFormData } from 'redux/actions/dataFormActions'
import { useNotations } from 'context/NotationsContext'
import { useFormBlocker } from 'hooks/useFormBlocker'
import { AlertErrorAlert } from 'components/Alerts/AlertErrorAlert'
import useStatusListener from 'hooks/useStatusListener'

/**
 * FormEntry - Componente principal desde el cual se maneja cabezera y cuerpo de formularios de entrada.
 *
 * @component
 * @return {Component} Retorna cabezera y cuerpo de formularios de entrada.
 */

const FormEntry = () => {
  const location = useLocation()
  const { FormEntryNumber = null } = queryString.parse(location.search)
  const token = useSelector(state => state.auth.dataUser.token)
  const [InfoUser, setInfoUser] = useState([])
  const dispatchRedux = useDispatch()
  const { resetNotations } = useNotations()
  const [openAlert] = AlertErrorAlert()

  const EditOrCreate = useCallback(
    async id => {
      try {
        const res = await __ShowForm(token, id, environment.FORMS_ENTRY_VIEW)
        const response = res.data.status.data
        setInfoUser(response)
        dispatchRedux(
          setFormData({ ...response, precision: Number(response?.precision) })
        )
      } catch (error) {}
    },
    [token]
  )

  useEffect(() => {
    return async () => dispatchRedux(clearFormData())
  }, [])

  useEffect(() => {
    if (FormEntryNumber) EditOrCreate(FormEntryNumber)
    if (!FormEntryNumber) resetNotations()
  }, [FormEntryNumber, EditOrCreate])

  const navigate = useNavigate()

  const { blockForm, formLockQueryResult } = useFormBlocker({
    form_id: FormEntryNumber || '',
    type_of: 'FMMI',
    userProvidedEndpoint: environment.FORMS_ON_EDIT
  })

  useEffect(() => {
    blockForm(1)
  }, [])

  useEffect(() => {
    if (formLockQueryResult?.code === 400) {
      openAlert(formLockQueryResult?.message, 'error')
      navigate(-1)
    }
  }, [formLockQueryResult])

  const navigateIfEligibleForUpdate = (
    flag,
    form_id,
    new_status,
    dataCurrent
  ) => {
    const shouldRefetch =
      flag === 'entry_form' &&
      (new_status !== 'DEVUELTO' || new_status !== 'BORRADOR') &&
      form_id === dataCurrent.id

    if (shouldRefetch) {
      navigate(`/FormShow?FormEntry=${form_id || FormEntryNumber}`)
      return
    }
  }

  useStatusListener({
    id: FormEntryNumber,
    callBack: navigateIfEligibleForUpdate,
    dataCurrent: InfoUser
  })

  return (
    <>
      <HeaderForm
        status={
          InfoUser?.status_entryForm === 'DEVUELTO' &&
          InfoUser?.status_entryForm
        }
        numberForm={FormEntryNumber && InfoUser.code_entryForm}
        UserQualified={FormEntryNumber && InfoUser.name_qualified}
        Modulo={
          InfoUser.length !== 0 && FormEntryNumber
            ? `Edición de formulario de ingreso en Zonas Francas`
            : `Creación de formulario de ingreso en Zonas Francas`
        }
      />

      <div>
        <BodyForm />
      </div>
    </>
  )
}

export default FormEntry
